export default __webpack_public_path__ + "static/media/case_green.3d948e40.svg";